<template>
  <img
    class="te-banner-set-badge mb-3 md:mb-4"
    src="~/assets/images/Te/TeCourse/SetBanner/Badge/set-badge-xs.png"
    alt="セット割"
    width="84"
    height="84"
    loading="lazy"
  >
</template>

<style scoped>
.te-banner-set-badge {
  position: absolute;
  top: 0;
  left: 0;
  width: 84px;
}
</style>
